import React from "react";
import CurrentRankReportView from "./CurrentRankReportView";

export default function CurrentPromoterRankReportPage() {
  return <CurrentRankReportView variant="promoter" />;
}
